import { IncidentVisualizerComponent } from "../../components/shared/incident-visualizer/incident-visualizer.component";


export class IncidentAttribute {
  mapEntityId: string;

  constructor(mapEntityId: string) {
    this.mapEntityId = mapEntityId;
  }

  getVisualizer() {
    return {
      component: IncidentVisualizerComponent,
      inputs: { mapentityid: this.mapEntityId }
    };
  }
}